import React from "react";

export default function OutlineButton({
  typeOfBtn,
  buttonText,
  onClick,
  disableButton,
}) {
  return disableButton ? (
    <div style={{ marginRight: "20px" }}>
      <button
        className="redoutline-button-outline"
        type={typeOfBtn}
        onClick={onClick}
        disabled
        style={{ background: "lightgray", color: "#ffffff", border: "none" }}
      >
        {buttonText}
      </button>
    </div>
  ) : (
    <div style={{ marginRight: "20px" }}>
      <button
        className="redoutline-button-outline"
        type={typeOfBtn}
        onClick={onClick}
      >
        {buttonText}
      </button>
    </div>
  );
}
